import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import * as Yup from 'yup';



export const mkValidationSchema = (multipleSources) => Yup.lazy((values) => {
  return (
    Yup.object().shape({
      name: Yup.string(),
      source: multipleSources ? Yup.array().min(1, 'Min 1 source required') : Yup.mixed(),
      field: Yup.string(),
      field_value: Yup.string(),
      version: Yup.string(),
      created_from: Yup.string().test(
        'test_date_after',
        'Created from date must be same or before than created to',
        (value) => {
          if (!isEmpty(values?.created_to) && !isEmpty(value)) {
            return moment(values?.created_to).isSameOrAfter(value);
          }
          return true;
        },
      ),
      created_to: Yup.string().test(
        'test_date_before',
        'Created from date must be same or after than created to',
        (value) => {
          if (!isEmpty(values?.created_from) && !isEmpty(value)) {
            return moment(values?.created_from).isSameOrBefore(value);
          }
          return true;
        },
      ),
    }));
});
